import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { InfluencerListSortField } from '@anytag/graphql';
import { SelectOption, SortOption } from '@anytag/shared-types';
import { CheckBox, CheckBoxProps, Form } from '@anytag/shared-atoms';
import { LIMIT, LIMIT_100, LIMIT_50 } from '@anytag/shared-constants';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { MarketplaceApplicantsSortFormValues, MarketplaceApplicantsSortFormKeys } from './types';

interface TemplateProps {
  onSubmit?: () => void;
  checkboxProps?: CheckBoxProps;
  sortOptions: SortOption<InfluencerListSortField>[];
}

export const Template = ({ onSubmit, sortOptions, checkboxProps }: TemplateProps) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<MarketplaceApplicantsSortFormValues>();

  const limitOptions: SelectOption<string>[] = [
    { value: LIMIT.toString(), label: t<string>('View_limit', { count: LIMIT }) },
    { value: LIMIT_50.toString(), label: t<string>('View_limit', { count: LIMIT_50 }) },
    { value: LIMIT_100.toString(), label: t<string>('View_limit', { count: LIMIT_100 }) }
  ];

  const handleSortChange: SingleSelectorFieldProps<
    MarketplaceApplicantsSortFormKeys,
    SortOption<InfluencerListSortField>
  >['onChange'] = (field, value, options) => {
    const selectedOption = options.find((option) => option.value === value);
    setValue(field, value);
    setValue('field', selectedOption?.field || null);
    setValue('order', selectedOption?.order || null);
  };

  return (
    <Form.Fields className="items-center">
      {checkboxProps ? (
        <Form.Field className="flex-none">
          <CheckBox help={t('Select all')} className="text-base font-semibold" {...checkboxProps} />
        </Form.Field>
      ) : null}

      <SelectorField<MarketplaceApplicantsSortFormKeys, SortOption<InfluencerListSortField>>
        name="sort"
        onSubmit={onSubmit}
        options={sortOptions}
        onChange={handleSortChange}
        className="ml-auto max-w-max min-w-30"
        placeholder={t<string>('Selector.Sort')}
      />

      <SelectorField<MarketplaceApplicantsSortFormKeys>
        name="limit"
        clearable={false}
        onSubmit={onSubmit}
        className="max-w-30"
        options={limitOptions}
      />
    </Form.Fields>
  );
};
